import { Map, Record } from 'immutable';
import { FETCHED_CURRENT_LESSON } from 'app/models/publishedLessonList/constants';

const PublishedLessonList = Record({
  currentByMaster: Map(),
}, 'PublishedLessonList');

export const publishedLessonListReducer = (state = PublishedLessonList(), action) => {
  switch (action.type) {
    case FETCHED_CURRENT_LESSON: {
      const { masterID, currentID } = action;
      return state.update('currentByMaster', (currentLessons) =>
        currentLessons.set(masterID, currentID));
    }

    default:
      return state;
  }
};
